export class Mgtfe{

  title: string;
  academicYear: string;
  tfeDescription: string;
  objectifsTfe: string;
  resumeTfe: string;
  objectifsRecherche: string;
  informationsUtiles: string;

}
